import { render, staticRenderFns } from "./YFormGroup.vue?vue&type=template&id=74bc5626&scoped=true"
import script from "./YFormGroup.vue?vue&type=script&lang=js"
export * from "./YFormGroup.vue?vue&type=script&lang=js"
import style0 from "./YFormGroup.vue?vue&type=style&index=0&id=74bc5626&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bc5626",
  null
  
)

export default component.exports